import React from 'react';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  variant?: 'dark' | 'light';
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ 
  title, 
  subtitle, 
  centered = true,
  variant = 'dark'
}) => {
  const textColor = variant === 'light' ? 'text-brand-white' : 'text-brand-dark';
  const subtitleColor = variant === 'light' ? 'text-brand-white/50' : 'text-brand-dark/50';
  
  return (
    // Заголовок: Полная ширина на мобильных, ограничение (имитация 6 колонок) на lg
    <div className={`mb-auto ${centered ? 'text-center' : 'text-left'} max-w-full lg:max-w-4xl mx-auto`}>
      <h2 className={`display-sm md:display-md lg:display-lg ${textColor} mb-4 leading-[1.1]`}>
        {title}
      </h2>
      {subtitle && (
        // Подзаголовок: Также полная ширина на мобильных, ограничение на lg для лучшей читаемости
        <p className={`body-base md:body-lg ${subtitleColor} max-w-full lg:max-w-2xl mx-auto leading-relaxed ${centered ? 'text-center' : 'text-left'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;